import { Grid, Typography } from "@mui/material"
import { useContext, useEffect, useState } from "react"
import OneTextArea from "../../../../../Components/OneTextArea/OneTextArea"
import OneInput from "../../../../../Components/OneInput/OneInput"
import { showNotify } from "../../../../../Utils/Utils"
import { WebSocketContext } from "../../../../../Providers/WebSocket/WebSocketContext"
import { CondominiosContext } from "../../../../../Providers/CondominiosContext/CondominiosContext"
import { styleBloco, styleButton, styleObs } from "./BaixarEntrega"
import OneButton from "../../../../../Components/OneButton/OneButton"
import { Check } from "@mui/icons-material"
import { UserContext } from "../../../../../Providers/UserContext/UserContex"
import { EncomendaContex } from "../../../../../Providers/EncomendaContext/EncomendaContext"

const BaixarEntrega = ({ setChecked, setOpenModalBaixaEntrega, encomenda }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const { condominios, activeCond } = useContext(CondominiosContext)
    const { user } = useContext(UserContext)
    const { procurarUltimaPesquisa } = useContext(EncomendaContex)
    const [formData, setFormData] = useState(null)
    const [disabled, setDisabled] = useState(false)
    const [contraSenha, setContraSenha] = useState(false)

    useEffect(() => {
        let condominio = condominios.find((cond) => cond.id_central == activeCond.id_central)
        setDisabled(!condominio.entrega_contra_senha)
        setContraSenha(condominio.entrega_contra_senha)
    }, [])

    const handleChange = (event) => {
        if (event.target.value !== undefined) {
            if (event.target.type == 'checkbox') {
                setFormData({ ...formData, [event.target.name]: event.target.checked })
            } else {
                setFormData({ ...formData, [event.target.name]: event.target.value })
            }
        }
    }

    const handleSubmit = () => {
        if (!formData) {
            showNotify("warning", "Nenhuma alteração feita!")
            return
        }

        let data = { id: encomenda.id_encomenda, id_central: activeCond.id_central, nomeOperador: user.nome, ...formData }

        if ((data.contra_senha == '' || data.contra_senha == undefined) && contraSenha) {
            showNotify("warning", "Contra senha é obrigatorio!")
            return
        }

        if (encomenda.cd_acesso !== undefined || encomenda.cd_acesso !== null || encomenda.cd_acesso !== 'null') {
            data = { ...data, cd_acesso: encomenda.cd_acesso }
        }

        if (encomenda.id_imovel !== undefined) {
            data = { ...data, id_imovel: encomenda.id_imovel }
        }

        if (data.nome_recebedor == "" || data.nome_recebedor == undefined) {
            showNotify("warning", "Nome é obrigatorio!")
            return
        }

        sendWs("BaixarEncomenda", data)
    }

    const BaixarEntrega = (msg) => {
        if (msg.data.status !== false) {
            showNotify('success', 'Baixa da Entrega feita com sucesso')
            setChecked(true)
            setOpenModalBaixaEntrega(false)
            procurarUltimaPesquisa()
        } else {
            showNotify('warning', msg.data.error)
        }
    }

    addRoute("BaixarEncomenda", BaixarEntrega)

    return (
        <Grid sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }} gap={2}>

            <Grid sx={styleBloco}>

                <Grid sx={{ width: '24%' }}>
                    <Typography>Contra Senha:</Typography>
                </Grid>

                <Grid>
                    <OneInput
                        onChange={handleChange}
                        name='contra_senha'
                        disabled={disabled}
                    />
                </Grid>

            </Grid>

            <Grid sx={styleBloco}>

                <Grid sx={{ width: '25%' }}>
                    <Typography>Nome:</Typography>
                </Grid>

                <Grid sx={{ width: '80%' }}>
                    <OneInput
                        onChange={handleChange}
                        name='nome_recebedor'
                    />
                </Grid>

            </Grid>

            <Grid sx={styleBloco}>

                <Grid sx={{ width: '30%' }}>
                    <Typography>Observação Recebedor:</Typography>
                </Grid>

                <Grid sx={styleObs}>
                    <OneTextArea
                        name="observacao_recebedor"
                        onChange={handleChange}
                    ></OneTextArea>
                </Grid>

            </Grid>

            <Grid sx={styleButton}>
                <OneButton
                    color="one_primary"
                    backgroundColor='true' variant="contained" onClick={handleSubmit} IconStart={Check} sxIconStart={{ width: '20px' }}>
                        CONCLUIR
                </OneButton>
            </Grid>
        </Grid>
    )
}

export default BaixarEntrega
